import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Logo.css'
import logoHero from "../../../assets/images/Logo Design.png";
import logoGallery from "../../../assets/images/Logo Design.png";

const LogoDesign = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Logo Design – BuddyTech Solutions </title>
        <meta name="description" content="Create memorable logos that reflect your company’s personality and values." />
        <meta name="keywords" content="logo design, brand identity" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Logo Design – BuddyTech Solutions" />
        <meta property="og:description" content="Create memorable logos that reflect your company’s personality and values." />
        <meta property="og:keywords" content="logo design, brand identity" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/graphics/logo" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Logo Design – BuddyTech Solutions" />
        <meta name="twitter:description" content="Create memorable logos that reflect your company’s personality and values." />
        <meta name="twitter:keywords" content="logo design, brand identity" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="logo-container">
        <header className="logo-hero">
          <div className="logo-hero-content">
            <h1>Logo Design Services</h1>
            <p>
              A logo is the face of your brand. We design memorable, scalable, and meaningful logos that tell your story in one glance.
            </p>
          </div>
          <img src={logoHero} alt="Logo Design Hero" className="logo-hero-img" />
        </header>

        <section className="logo-section">
          <div className="logo-text">
            <h2>What You Get</h2>
            <p>
              Whether you’re a startup or an established business, we craft custom logos that match your vision and leave a lasting impression. From concept sketches to final vector delivery, we cover every step.
            </p>
            <ul>
              <li>Unique Concept Development</li>
              <li>Scalable Vector Formats</li>
              <li>Color & Monochrome Versions</li>
              <li>Brand Style Guide (Optional)</li>
              <li>Fast Turnaround & Revisions</li>
            </ul>
          </div>
          <img src={logoGallery} alt="Logo Samples" className="logo-img" />
        </section>

        <section className="logo-tools">
          <h2>Design Tools We Use</h2>
          <div className="tools-grid">
            <span>Adobe Illustrator</span>
            <span>Figma</span>
            <span>Canva</span>
            <span>CorelDRAW</span>
            <span>Affinity Designer</span>
            <span>Sketch</span>
          </div>
        </section>

        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919842084312">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default LogoDesign;